import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  max-height: 100vh;
  background-color: white;
  border-right: 1px solid;
  border-color: #c3c3c3;
`;

export const Header = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 8px;
`;

export const SearchBox = styled.div`
  padding: 8px;
  border-bottom: 1px solid;
  border-color: #c3c3c3;
`;

export const ContactsWrapper = styled.div`
  overflow-y: auto;
  height: ${(props) => props.height};
`;
